import axios from 'axios'
// import da from 'element-ui/src/locale/lang/da'

function joinParams(params) {
  let str = '';
  for (let key in params) {
    str += `${key}=${params[key]}&`;
  }
  str = str.slice(0, -1);
  return str;
}

export function chat_get(api, params, callback, fcb) {
  return axios({
    method:'get',
    url: api,
    params
  }).then(res=> {
    if(!!callback) callback(res);
  }).catch(err => {
    if (fcb) fcb(err);
  })
}

export function chat_get_file(api, params, callback, fcb) {
  return axios({
    method:'get',
    url: api,
    params,
    responseType: 'blob'
  }).then(res=> {
    if(!!callback) callback(res);
  }).catch(err => {
    if (fcb) fcb(err);
  })
}

export function chat_post_file(api, data, callback, fcb) {
  return axios({
    method:'post',
    url: api,
    data,
    responseType: 'blob'
  }).then(res=> {
    if(!!callback) callback(res);
  }).catch(err => {
    if (fcb) fcb(err);
  })
}

export function chat_post(api, data, callback, fcb) {
  return axios({
    method:'post',
    data,
    url: api
  }).then(res=> {
    if(!!callback) callback(res);
  }).catch(err => {
    if (fcb) fcb(err);
  })
}

export function chat_del(api, data, callback, fcb) {
  return axios({
    method:'delete',
    data,
    url: api
  }).then(res=> {
    if(!!callback) callback(res);
  }).catch(err => {
    if (fcb) fcb(err);
  })
}

export function toForm(data) {
  let params = new FormData()
  let dataKeys = Object.keys(data)
  dataKeys.forEach(item => {
    params.append(item, data[item])
  })
  return params
}

export function handleTree(data, id, parentId, children, rootId) {
  id = id || 'id'
  parentId = parentId || 'parentId'
  children = children || 'children'
  rootId = rootId || 0
  //对源数据深度克隆
  const cloneData = JSON.parse(JSON.stringify(data))
  //循环所有项
  const treeData =  cloneData.filter(father => {
    let branchArr = cloneData.filter(child => {
      //返回每一项的子级数组
      return father[id] === child[parentId]
    });
    branchArr.length > 0 ? father.children = branchArr : '';
    //返回第一层
    return father[parentId] === rootId;
  });
  return treeData != '' ? treeData : data;
}


